import { render, staticRenderFns } from "./Andar.vue?vue&type=template&id=9bf32d82&"
import script from "./Andar.vue?vue&type=script&lang=js&"
export * from "./Andar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports